import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../utils/cn';
const badgeVariants = {
    default: 'bg-primary text-primary-foreground hover:bg-primary/80',
    secondary: 'bg-secondary text-secondary-foreground hover:bg-secondary/80',
    outline: 'text-foreground border border-input',
    destructive: 'bg-destructive text-destructive-foreground hover:bg-destructive/80',
    success: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300',
};
const badgeSizes = {
    default: 'h-6 px-2.5 text-xs',
    sm: 'h-5 px-2 text-xs',
    lg: 'h-7 px-3 text-sm',
};
export function Badge({ className, variant = 'default', size = 'default', ...props }) {
    return (_jsx("div", { className: cn('inline-flex items-center rounded-full font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2', badgeVariants[variant], badgeSizes[size], className), ...props }));
}
